<template>
    <b-modal id="modal-edit-folder" :title="title" modal-class="modal-w-md">

        <div class="form form-modal mb-4">
            <b-form-input class="form-control--mid" v-model="folder.name" placeholder="Enter Folder Name*"></b-form-input>
        </div>

        <b-form-textarea class="form-control--mid" placeholder="Enter Description" v-model="folder.description">

        </b-form-textarea>

        <h4 class="heading4 mt-3">Permissions</h4>

        <ul class="rows-list mb-3">

            <li class="rows-list__form">
                <!-- Please add here the logic first -->

                <multiselect class="multiselect-mid col-sm-5 mb-2 mb-sm-0"
                     v-model="newPermission.holder"
                     :options="actualPermissionHolders"
                     select-label=""
                     deselect-label=""
                     label="name"
                     track-by="name"
                >
                    <template slot="option" slot-scope="props">
                        <template v-if="props.option.type == 'group'">
                            <div class="d-flex align-items-center">
                                <div class="mr-2">
                                    <font-awesome-icon :icon="['fa', 'users']" size="lg"  />
                                </div>
                                {{ props.option.name }}
                            </div>

                        </template>
                        <template v-else>
                            <div class="d-flex align-items-center">
                                <div class="mr-2">
                                    <Avatar
                                        :username="props.option.name"
                                        :src="props.option.avatar"
                                        :size="30">
                                    </Avatar>
                                </div>
                                {{ props.option.name }}
                            </div>
                        </template>
                    </template>
                </multiselect>

                <template v-if="roles.length">
                    <span class="text-nowrap ml-sm-2">Add as:</span>
                    <b-dropdown class="modal-list mx-3 dropdown--tertiary" variant="link" ref="roleDropdown"
                                toggle-class="text-decoration-none" no-caret>

                        <template #button-content>
                            {{ newPermission.role.name }}
                        </template>

                        <!--<b-dropdown-header>-->
                        <b-dropdown-item v-for="role in roles" :key="role.id"
                                         @click="newPermission.role = role; $refs.roleDropdown.hide()">
                            <!--<li>-->
                            <!--<ul class="modal-list modal-list--permission">-->
                            <!--<li>-->
                            <h5 class="heading5 heading5--secondary">{{ role.name }}</h5>
                            <p>{{ role.description }}</p>
                            <!--</li>-->
                            <!--</ul>-->
                            <!--</li>-->
                            <!--</b-dropdown-header>-->
                        </b-dropdown-item>

                    </b-dropdown>
                </template>

                <b-button @click="addPermission" variant="primary" size="md" :disabled="!newPermission.holder">Add</b-button>
            </li>

            <li v-for="(permission, index) in folder.permissions" :key="index">
                <div class="image-block image-block--rounded">
                    <Avatar
                        :username="permission.name"
                        :src="permission.avatar"
                        :size="30">
                    </Avatar>
                    <img v-if="permission.type === 'user'" :src="permission.avatar" alt=""/>
                </div>

                <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>

                <b-dropdown v-if="roles.length" class="ml-auto dropdown--tertiary modal-list" variant="link"
                            toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <h5 class="heading5 heading5--secondary text-capitalize">{{ permission.role.name }}</h5>
                    </template>

                    <b-dropdown-item v-for="(role, index) in roles" :key="index" @click="permission.role = role">
                        <h5 class="heading5 heading5--secondary">{{ role.name }}</h5>
                        <p>{{ role.description }}</p>
                    </b-dropdown-item>
                </b-dropdown>

                <a @click="folder.permissions.splice(index, 1)" class="link-remove link" href="#">Remove</a>
            </li>
        </ul>

        <template #modal-footer>
            <b-button variant="primary" size="lg" :disabled="!canSave" @click="save">Save</b-button>
        </template>
    </b-modal>
</template>

<script>

import trackersFolders from "@/services/trackers-folders.service";
import companies from "@/services/company.service";
import team from "@/services/team.service";
import multiselect from "vue-multiselect";
import Avatar from 'vue-avatar';

export default {
    components: {
        multiselect,
        Avatar
    },

    data() {
        return {
            folder: {
                name: "",
                description: "",
                permissions: [],
            },

            id: 0,

            permissionHolders: [],
            newPermission: {
                holder: null,
                role: {
                    id: 0,
                    name: "",
                    description: "",
                },
            },

            roles: [],

            usersList: {},

        }
    },

    mounted() {
        if (this.$store.getters.isEnterprise) {
            companies.getRoles().then(result => {
                this.roles = result.data

                this.newPermission.role = this.roles[0]
            })
        }
    },

    computed: {
        title() {
            if (this.id) {
                return "Edit Folder"
            } else {
                return "Create New Folder"
            }
        },

        canSave() {
            return this.folder.name.length
        },

        actualPermissionHolders() {
            let array = []
            this.permissionHolders.forEach(item => {
                if (!this.arrayHelper.exists(this.folder.permissions, ['type', 'id'], [item.type, item.id])) {
                    array.push(item)
                }
            })

            return array
        }
    },

    methods: {

        init() {
            this.newPermission.holder = null

            this.folder.name = ""
            this.folder.description = ""
            this.folder.permissions = []
            this.getPermissionHolders()

            if (this.id) {
                trackersFolders.getEdit(this.id).then(response => {
                    this.folder.name = response.data.name
                    this.folder.description = response.data.description
                    this.folder.permissions = response.data.permissions
                })
            } else {
                if (this.$store.state.user.id) {
                    this.folder.permissions.push({
                        type: 'user',
                        id: this.$store.state.user.id,
                        name: this.$store.state.user.name,
                        avatar: this.$store.state.user.avatar,
                        role: this.roles[0],
                    })
                } else {
                    this.folder.permissions.push({
                        type: 'user',
                        id: this.$store.state.user.id,
                        name: this.$store.state.user.name,
                        avatar: this.$store.state.user.avatar,
                        role: this.roles[0],
                    })
                }
            }
        },

        getPermissionHolders() {
            team.getPermissionHolders().then(response => {
                this.permissionHolders = response.data
            })
        },

        open(id) {
            this.id = id
            this.init()
            this.$bvModal.show('modal-edit-folder')
        },

        addPermission() {
            this.folder.permissions.push(
                {
                    type: this.newPermission.holder.type,
                    id: this.newPermission.holder.id,
                    name: this.newPermission.holder.name,
                    role: this.newPermission.role,
                    avatar: this.newPermission.holder.avatar,
                }
            )

            this.newPermission.holder = null
        },

        removeUser(index) {
            this.users.splice(index, 1)
        },

        save() {
            trackersFolders.save(this.id, this.folder).then(() => {
                this.$emit('folderSaved')
                this.$bvModal.hide('modal-edit-folder')
            })
        }
    }
}
</script>
